import type { ShopperCustomersTypes } from 'commerce-sdk-isomorphic'
import { DataLayerEventName } from '~/helpers/datalayer/types'

export const buildUser = (user: Readonly<ShopperCustomersTypes.Customer>): UserDataLayer => {
  const { $braze } = useNuxtApp()

  let preferredAddress =
    user?.addresses?.find((address: ShopperCustomersTypes.CustomerAddress) => address.preferred) || undefined

  return {
    id: user?.customerId || '',
    cid: $braze.sdk.getUser()?.getUserId() || '', // Empty string fallback only for defensive code, expect CID for logged-in Users
    customerNumber: user?.customerNo || '', // TODO: Deprecated field - https://dev.azure.com/michaelhill/Ecommerce/_workitems/edit/231850
    loggedIn: !!user,
    type: user ? user.authType : 'guest',
    postcode: preferredAddress?.postalCode || '',
    state: preferredAddress?.stateCode || preferredAddress?.city || '',
    email: user ? user.email : '',
    phone: user ? user.phoneHome : '',
    sessionId: user?.customerId || '', // FIXME: Should be the SFCC session ID, not customer ID
    customerName: user ? [user.firstName, user.lastName].join(' ') : '',
    brazeDeviceId: $braze.sdk.getDeviceId() ?? '',
  }
}

const buildMyAccountPayload = (eventType: DataLayerEventName, options: any): DataLayerOptional => {
  const baseDataLayer = {
    event: eventType,
    category: 'brilliance',
  }
  const userPayload = buildUser(options.user)

  const createAuthenticationDataLayer = (): DataLayerOptional => {
    return {
      ...baseDataLayer,
      method: 'email',
      user: userPayload,
    }
  }

  const createClickFormDataLayer = (config: any): DataLayerOptional => {
    return {
      ...baseDataLayer,
      group: config?.group,
      label: config?.label,
      info: {
        url: config?.url,
      },
    }
  }

  const createFormSubmitDataLayer = (config: any): DataLayerOptional => {
    return {
      ...baseDataLayer,
      group: config?.group,
      data: config?.data,
    }
  }

  const eventTypeMapping = {
    'custom.user.login': createAuthenticationDataLayer,
    'custom.form.click': createClickFormDataLayer,
    'custom.form.complete': createFormSubmitDataLayer,
  } satisfies Partial<Record<DataLayerEventName, Function>>

  const dataLayerHandler = eventTypeMapping[eventType]

  if (!dataLayerHandler) {
    throw new Error('Invalid event type')
  }

  return dataLayerHandler(options)
}

export const trackMyAccountEvent = (event: DataLayerEventName, option: any, locale: Locales) => {
  const payload = buildMyAccountPayload(event, option)
  pushEventToDataLayer(event, payload, locale)
}
